import { CLEAR_WORKSPACES_APPLICATIONS_USERS_SETTINGS } from './index';

export const clearWorkspacesApplicationsUsersSettingsAction = (settings) => ({
	type: CLEAR_WORKSPACES_APPLICATIONS_USERS_SETTINGS,
	settings
});